class TealiumService
  constructor: ($window) ->
    @$window = $window

  tealiumIsEnabled: () -> !!@$window.tealium_enabled

  formatData: (data) ->
    # Tealium expects all values to be strings
    formatted_data = {}
    Object.entries(data).forEach(([key, val]) ->
      if Array.isArray(val)
        formatted_data[key] = val.map((v) -> String(v))
      else
        formatted_data[key] = String(val)
    )
    formatted_data

  # utag and amount_tag methods should be called with safe property chaining
  # because ad-blocking extensions may prevent those variables from being defined.
  # In some cases, calling methods on them will then cause AngularJS to crash,
  # although this behavior is inconsistent across browsers, extensions, and even
  # sessions.

  # Due to Tealium configurations that can longer be un-done,
  #   1. utag sends events to HSBC's account
  #   2. amount_tag sends events to amount/tenant, where the
  #      tenant would need an extension that duplicates
  #      the event and event data (see amount/avant for an example)

  view: (viewData = {}) ->
    return unless @tealiumIsEnabled()
    dataToSubmit = @formatData(viewData)
    @$window.amount_tag?.view(dataToSubmit)
    @$window.utag?.view(dataToSubmit)

  sendEvent: (eventData = {}) ->
    return unless @tealiumIsEnabled()
    dataToSubmit = @formatData(eventData)
    @$window.amount_tag?.link(dataToSubmit)
    @$window.utag?.link(dataToSubmit)

angular
.module("avant.tealium")
.service("TealiumService", [
  "$window",
  TealiumService
])

if typeof exports != 'undefined'
  if typeof module != 'undefined' && module.exports
    exports = module.exports = TealiumService
  exports.TealiumService = TealiumService
else
  window.TealiumService = TealiumService
